const REQUIRED_SN_PATTERN = /^SN:\s*([A-Z0-9]+)$/i
const PLAIN_TERMINAL_CODE_PATTERN = /^[A-Z0-9]+$/i

const normalizeTerminalCode = (value: string) => {
  const normalizedValue = value.trim()
  if (!normalizedValue) {
    return ''
  }

  const snMatch = normalizedValue.match(REQUIRED_SN_PATTERN)
  if (snMatch?.[1]) {
    return snMatch[1].trim().toUpperCase()
  }

  if (PLAIN_TERMINAL_CODE_PATTERN.test(normalizedValue)) {
    return normalizedValue.toUpperCase()
  }

  return ''
}

export { normalizeTerminalCode }
